import { cn } from '../../lib/utils';
import { InputHTMLAttributes, forwardRef } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /**
   * To show error message
   */
  isError?: boolean;
}

/**
 * Primary Text Input component
 */

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, isError, readOnly, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'w-full rounded-[6px] border border-[#D2D5DA] bg-white p-2.5 text-sm shadow-[0_2px_4px_rgba(0,0,0,0.05)] placeholder:text-[#A5AAB1] focus:border-[#D2D5DA] focus:ring-0 disabled:bg-slate-100 disabled:text-paragraph-lite',
          {
            'border-primary focus:border-primary': isError,
            'text-paragraph-lite': readOnly,
          },
          className
        )}
        ref={ref}
        readOnly={readOnly}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export default Input;
